module.exports = __webpack_public_path__ + "static/media/computers2.b6ea1e64.png";